// Estilos globales para todo el módulo add-panel
export const addPanelGlobalStyles = `
  /* Tipografía global para add-panel */
  .add-panel-container {
    font-family: 'Inter', -apple-system, BlinkMacSystemFont, 'Segoe UI', 'Roboto', sans-serif;
    font-size: 14px;
    line-height: 1.5;
  }

  /* Colores globales */
  .add-panel-primary {
    color: #0891b2;
  }

  .add-panel-secondary {
    color: #6b7280;
  }

  /* Espaciado consistente */
  .add-panel-spacing-sm {
    padding: 8px;
  }

  .add-panel-spacing-md {
    padding: 16px;
  }

  .add-panel-spacing-lg {
    padding: 24px;
  }

  /* Bordes y sombras consistentes */
  .add-panel-card {
    border-radius: 8px;
    box-shadow: 0 1px 3px 0 rgba(0, 0, 0, 0.1);
    border: 1px solid #e5e7eb;
  }

  /* Botones consistentes */
  .add-panel-button {
    border-radius: 6px;
    font-weight: 500;
    transition: all 0.2s ease-in-out;
  }

  .add-panel-button:hover {
    transform: translateY(-1px);
    box-shadow: 0 4px 12px 0 rgba(0, 0, 0, 0.15);
  }
`;

// Función para aplicar estilos globales
export const applyGlobalStyles = () => {
  if (typeof document !== 'undefined') {
    const styleId = 'add-panel-global-styles';
    let styleElement = document.getElementById(styleId);

    if (!styleElement) {
      styleElement = document.createElement('style');
      styleElement.id = styleId;
      styleElement.textContent = addPanelGlobalStyles;
      document.head.appendChild(styleElement);
    }
  }
};

// Tema de colores centralizado
export const addPanelTheme = {
  colors: {
    primary: '#0891b2',
    secondary: '#6b7280',
    success: '#10b981',
    warning: '#f59e0b',
    error: '#ef4444',
    background: '#ffffff',
    surface: '#f9fafb',
    border: '#e5e7eb',
  },
  typography: {
    fontFamily: "'Inter', -apple-system, BlinkMacSystemFont, 'Segoe UI', 'Roboto', sans-serif",
    fontSize: {
      xs: '12px',
      sm: '14px',
      base: '16px',
      lg: '18px',
      xl: '20px',
    },
    fontWeight: {
      normal: 400,
      medium: 500,
      semibold: 600,
      bold: 700,
    },
  },
  spacing: {
    xs: '4px',
    sm: '8px',
    md: '16px',
    lg: '24px',
    xl: '32px',
  },
  borderRadius: {
    sm: '4px',
    md: '6px',
    lg: '8px',
    xl: '12px',
  },
  shadows: {
    sm: '0 1px 2px 0 rgba(0, 0, 0, 0.05)',
    md: '0 1px 3px 0 rgba(0, 0, 0, 0.1)',
    lg: '0 4px 6px -1px rgba(0, 0, 0, 0.1)',
  },
};
